import { Controller } from "@hotwired/stimulus"
import TomSelect from "@lib/custom-tom-select"
import { get } from "@lib/requests"

// Connects to data-controller="client-animals"
export default class extends Controller {

  static targets = ["client", "animals"]
  static values = {
    allowDisabled: { type: Boolean, default: false }
  }
  
  connect() {
    // Destroy existing Tom Select instances if they exist (e.g., from previous connection)
    if (this.clientTarget.tomselect) {
      this.clientTarget.tomselect.destroy()
    }
    if (this.animalsTarget.tomselect) {
      this.animalsTarget.tomselect.destroy()
    }

    const clientOptions = { labelField: "name", valueField: "id", searchField: [] }
    const animalOptions = { labelField: "name", valueField: "id", searchField: ["name"], maxOptions: null }
    this.clientSelect = new TomSelect(this.clientTarget, { maxItems: 1, onChange: this.onClientChange.bind(this), load: this.loadClients.bind(this), ...clientOptions })
    this.animalsSelect = new TomSelect(this.animalsTarget, animalOptions)
  }

  disconnect() {
    if (this.clientSelect) {
      this.clientSelect.destroy()
    }
    if (this.animalsSelect) {
      this.animalsSelect.destroy()
    }
  }

  async loadClients(query, callback) {
    this.clientSelect.clearSelect()

    if (!query.trim()) {
      callback([])
      return
    }

    const params = new URLSearchParams({ q: query })
    if (this.allowDisabledValue) params.set("allow_disabled", "true")
    const queryUrl = `/api/v1/clients?${params}`
    const response = await fetch(queryUrl, { headers: { accept: "application/json" } })
    const results = await response.json()
    callback(results || [])
  }
  
  async onClientChange() {
    
    // Firstly clear the selection and options
    this.animalsSelect.clear()
    this.animalsSelect.clearOptions()

    // Find the possible town element
    const clientTown = document.getElementById("client-town")

    // If client value is now empty, return here
    if (!this.clientTarget.value) {

      // If we have a town element, clear it
      if (clientTown) {
        const input = clientTown.querySelector("input")
        input.value = ""
        const link = clientTown.querySelector("a")
        link.href = ""
        link.innerHTML = ""
      }
      
      return
    }

    // Set the clientId
    const clientId = this.clientTarget.value

    // Else go and fetch animals for the client
    try {
      const response = await fetch(`/api/v1/animals?client_id=${clientId}`, { headers: { accept: "application/json" } })
      const animals = await response.json()
      
      // Apply the new options to the animals select
      this.animalsSelect.addOptions(animals)
      
      // Refresh the animals select
      this.animalsSelect.refreshOptions()
    
    } catch (error) {
      console.error(`There was an error fetching animals for client ${clientId}: ${error}`)
    }

    if (!clientTown)  return

    // If the client has an address and we find a target element with id "client-town", then set it..
    try {
      const addressResponse = await fetch(`/api/v1/clients/${clientId}/address`, { headers: { accept: "application/json" } })
      const address = await addressResponse.json()
      if (address?.town) {
        const input = clientTown.querySelector("input")
        input.value = address.town
        const link = clientTown.querySelector("a")
        link.href = address.url
        link.classList.add("mt-1", "ml-1")
        link.innerHTML = `
          <span class="text-xs text-gray-500 italic">Adresse: ${address.string}</span>
          <i class="fal fa-external-link-alt ml-2 text-xs text-gray-500"></i>
        `
      }
    } catch (error) {
      console.error(`There was an error fetching address for client ${clientId}: ${error}`)
    }

  }
  
}
